/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateYoutubeVideoConfigEnableReqVo
 */
export interface UpdateYoutubeVideoConfigEnableReqVo {
    /**
     * 是否可用：0不可用，1可用
     * @type {number}
     * @memberof UpdateYoutubeVideoConfigEnableReqVo
     */
    enable: number;
}

/**
 * Check if a given object implements the UpdateYoutubeVideoConfigEnableReqVo interface.
 */
export function instanceOfUpdateYoutubeVideoConfigEnableReqVo(value: object): value is UpdateYoutubeVideoConfigEnableReqVo {
    if (!('enable' in value) || value['enable'] === undefined) return false;
    return true;
}

export function UpdateYoutubeVideoConfigEnableReqVoFromJSON(json: any): UpdateYoutubeVideoConfigEnableReqVo {
    return UpdateYoutubeVideoConfigEnableReqVoFromJSONTyped(json, false);
}

export function UpdateYoutubeVideoConfigEnableReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateYoutubeVideoConfigEnableReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'enable': json['enable'],
    };
}

export function UpdateYoutubeVideoConfigEnableReqVoToJSON(json: any): UpdateYoutubeVideoConfigEnableReqVo {
    return UpdateYoutubeVideoConfigEnableReqVoToJSONTyped(json, false);
}

export function UpdateYoutubeVideoConfigEnableReqVoToJSONTyped(value?: UpdateYoutubeVideoConfigEnableReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enable': value['enable'],
    };
}

